
export enum WorkflowSteps {
  ApplicantConfiguration = 'ApplicantConfiguration',
  ServiceDetailsConfiguration = 'ServiceDetailsConfiguration',
  AttachmentsConfiguration = 'AttachmentsConfiguration',
  ReviewConfiguration = 'ReviewConfiguration',
  Congratulations = 'Congratulations'
}
